import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Typography, Spin, Tag, message } from "antd";
import { TeamOutlined, CheckCircleTwoTone, UserOutlined } from "@ant-design/icons";
import { API_BASE_URL } from "../../config/api";
import "./main.css";

const { Title, Text } = Typography;

function WorkspacePicker() {
  const navigate = useNavigate();
  const [workspaces, setWorkspaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [switching, setSwitching] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const baseURL = API_BASE_URL;

  useEffect(() => {
    fetch(`${baseURL}/team/my-workspaces`, {
      headers: { "Authorization": localStorage.getItem("token") }
    })
      .then(res => res.json())
      .then(data => {
        setLoading(false);
        if (data?.message === "Success") {
          setWorkspaces(data.data || []);
          // If no workspaces, go to ig-connect
          if (!data.data?.length) {
            navigate("/ig-connect?show_ig_connect=true");
          }
        }
      })
      .catch(() => {
        setLoading(false);
        navigate("/ig-connect?show_ig_connect=true");
      });
  }, []);

  const handleSwitch = (ws) => {
    localStorage.setItem("personal_token", localStorage.getItem("token"));
    localStorage.setItem("token", ws.token);
    localStorage.setItem("current_workspace_id", ws.workspace_id);
    const ud = JSON.parse(localStorage.getItem("userData") || "{}");
    ud.workspace_id = ws.workspace_id;
    ud.workspace_role = ws.role;
    localStorage.setItem("userData", JSON.stringify(ud));
    navigate("/ig");
  };

  const handlePersonal = () => {
    navigate("/ig-connect?show_ig_connect=true");
  };

  if (loading) {
    return (
      <div className="workspace-picker-container">
        <Spin size="large" />
      </div>
    );
  }

  const itemStyle = (isActive) => ({
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "14px 16px",
    borderRadius: "10px",
    cursor: switching ? "not-allowed" : "pointer",
    transition: "all 0.2s ease",
    backgroundColor: isActive ? "#f0f7ff" : "#fff",
    border: isActive ? "1px solid #d6e4ff" : "1px solid #f0f0f0",
    opacity: switching ? 0.6 : 1
  });

  return (
    <div className="workspace-picker-container">
      {contextHolder}
      <Card className="workspace-picker-card" bordered>
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <TeamOutlined style={{ fontSize: "40px", color: "#1890ff", marginBottom: "12px" }} />
          <Title level={3} style={{ margin: 0 }}>Select a Workspace</Title>
          <Text type="secondary">Choose a workspace to get started</Text>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          {/* Personal account option */}
          <div
            onClick={() => !switching && handlePersonal()}
            style={itemStyle(false)}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#fafafa"; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#fff"; }}
          >
            <div style={{ width: "40px", height: "40px", borderRadius: "50%", backgroundColor: "#f0f0f0", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <UserOutlined style={{ fontSize: "18px", color: "#595959" }} />
            </div>
            <div style={{ flex: 1 }}>
              <p style={{ margin: 0, fontSize: "15px", fontWeight: "500", color: "#262626" }}>My Account</p>
              <p style={{ margin: 0, fontSize: "12px", color: "#8c8c8c" }}>Connect your own Instagram</p>
            </div>
          </div>

          {workspaces.map((ws) => (
            <div
              key={ws.workspace_id}
              onClick={() => !switching && handleSwitch(ws)}
              style={itemStyle(false)}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#f0f7ff"; e.currentTarget.style.borderColor = "#d6e4ff"; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#fff"; e.currentTarget.style.borderColor = "#f0f0f0"; }}
            >
              <div style={{ width: "40px", height: "40px", borderRadius: "50%", backgroundColor: "#e6f7ff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <TeamOutlined style={{ fontSize: "18px", color: "#1890ff" }} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ margin: 0, fontSize: "15px", fontWeight: "500", color: "#262626", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {ws.name}
                </p>
                <Tag color={ws.role === "owner" ? "red" : ws.role === "admin" ? "blue" : "green"} style={{ marginTop: "4px", fontSize: "11px" }}>
                  {ws.role?.toUpperCase()}
                </Tag>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}

export default WorkspacePicker;
